import { setLoading, setAuthorize } from '../actions'
import { setReportModuleAccessRights } from '../../../scenes/Gnosus/scenes/Report/actions'
import { setPortfolioModuleAccessRights } from '../../../scenes/Gnosus/scenes/Portfolio/actions'
import reducer, { UserRecord, LicenseRecord } from '../reducer'

import { transformReportAccessRightsData, transformPortfolioAccessRightsData } from '../helpers'

import { AuthorizationRecordMock, AccessRightRecordMock, ModuleAccessRightRecordMock } from './utils/records'
import { accessRightsReport, accessRightsPortfolio } from './utils/mockData'

const stateMock = AuthorizationRecordMock()

describe('Authorization service reducer', () => {
    test('case LOGIN_REQUEST_SUCCESS', () => {
        const sessionId = '123456789'
        const expectState = AuthorizationRecordMock({ sessionId })
        const action = { type: 'LOGIN_REQUEST_SUCCESS', payload: { response: { body: { sessionId } } } }

        expect(reducer(stateMock, action)).toEqual(expectState)
    })

    test('case USER_INFO_REQUEST_SUCCESS', () => {
        const sessionId = '123456789'
        const expectState = AuthorizationRecordMock({
            sessionId,
            user: UserRecord({
                firstName: 'TestFirstName',
                lastName: 'TestLastName',
                email: 'TestEmail',
                productId: 'TestProductId',
            }),
            license: LicenseRecord(),
        })
        const action = {
            type: 'USER_INFO_REQUEST_SUCCESS',
            payload: {
                originAction: { payload: { qs: { sid: sessionId } } },
                response: {
                    body: [
                        {
                            firstName: 'TestFirstName',
                            lastName: 'TestLastName',
                            email: 'TestEmail',
                            productId: 'TestProductId',
                        },
                    ],
                },
            },
        }

        expect(reducer(stateMock, action)).toEqual(expectState)
    })

    test('case AVAILABLE_MODULES_REQUEST_SUCCESS', () => {
        const rights = {
            moduleHome: 1,
            moduleLinkAnalysis: 1,
            moduleReport2: 1,
        }
        const expectState = AuthorizationRecordMock()
            .setIn(['accessRights', 'home', 'available'], true)
            .setIn(['accessRights', 'linkages', 'available'], true)
            .setIn(['accessRights', 'report', 'available'], true)
            .setIn(['accessRights', 'home', 'hasRights'], true)
            .setIn(['accessRights', 'linkages', 'hasRights'], true)
            .setIn(['accessRights', 'report', 'hasRights'], true)
        const action = { type: 'AVAILABLE_MODULES_REQUEST_SUCCESS', payload: { response: { body: [rights] } } }

        expect(reducer(stateMock, action)).toEqual(expectState)
    })

    test('case SET_REPORT_MODULE_ACCESS_RIGHTS', () => {
        const expectState = AuthorizationRecordMock({
            accessRights: AccessRightRecordMock({
                report: ModuleAccessRightRecordMock({
                    key: 'report',
                    order: 2,
                    custom: transformReportAccessRightsData(accessRightsReport.types),
                    isCustomLoaded: true,
                    available: true,
                }),
            }),
        })
        const action = setReportModuleAccessRights(accessRightsReport)

        expect(reducer(stateMock, action)).toEqual(expectState)
    })

    test('case SET_PORTFOLIO_MODULE_ACCESS_RIGHTS', () => {
        const expectState = AuthorizationRecordMock({
            accessRights: AccessRightRecordMock({
                portfolio: ModuleAccessRightRecordMock({
                    key: 'portfolio',
                    order: 8,
                    custom: transformPortfolioAccessRightsData(accessRightsPortfolio.types),
                    isCustomLoaded: true,
                    available: true,
                }),
            }),
        })
        const action = setPortfolioModuleAccessRights(accessRightsPortfolio)

        expect(reducer(stateMock, action)).toEqual(expectState)
    })

    describe('case SET_LOADING', () => {
        test('set to true', () => {
            const expectState = AuthorizationRecordMock({ isLoading: true })

            expect(reducer(stateMock, setLoading(true))).toEqual(expectState)
        })

        test('set to false', () => {
            const expectState = AuthorizationRecordMock({ isLoading: false })

            expect(reducer(stateMock, setLoading(false))).toEqual(expectState)
        })
    })

    describe('case SET_AUTHORIZE', () => {
        test('set to true', () => {
            const expectState = AuthorizationRecordMock({ isAuthorized: true })

            expect(reducer(stateMock, setAuthorize(true))).toEqual(expectState)
        })

        test('set to false', () => {
            const expectState = AuthorizationRecordMock({ isAuthorized: false })

            expect(reducer(stateMock, setAuthorize(false))).toEqual(expectState)
        })
    })

    test('case default', () => {
        const expectState = AuthorizationRecordMock()

        expect(reducer(stateMock)).toEqual(expectState)
    })
})
